/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability to ListItem and ListItemWithPopup to be displayed either using icon or quickAccessIcon.
 * Its default value is false. When its value is set to true, the widget would be displayed using the quickAccessIcon.
 * When its value is false, the widget would be displayed using the icon.
 * <br><br>
 *
 * @module MW/toolstrip/mixins/UseQuickAccessIconMixin
 *
 * @copyright Copyright 2016 The MathWorks, Inc.
 */
define([
    "dojo/_base/declare",
    "mw-form/mixins/property/IconMixin"
], function (declare, IconMixin) {

    var UseQuickAccessIconMixin = declare(null, {
        /**
         * @property  {boolean} useQuickAccessIcon
         * @instance
         */
        useQuickAccessIcon: false,

        postCreate: function(){
            this.inherited(arguments);
            this.set("useQuickAccessIcon", this.get("useQuickAccessIcon"));
        },

        _setUseQuickAccessIconAttr: function(useQuickAccessIcon){
            if (typeof useQuickAccessIcon !== "boolean") {
                throw new Error("'useQuickAccessIcon' property expects a boolean!");
            }

            this._set("useQuickAccessIcon", useQuickAccessIcon);
            if (useQuickAccessIcon) {
                this.set("iconProp", "quickAccessIcon");
            } else {
                this.set("iconProp", "icon");
            }
        }
    });

    UseQuickAccessIconMixin._dependencies = [
        {mixin: IconMixin, orderDependent: false}
    ];

    return UseQuickAccessIconMixin;


});
